import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { modifiers as m } from 'vue-tsx-support';
import { ArrowLeft, LogIn } from '@codegrade/icons';
import { Just, Maybe } from '@codegrade/maybe';
import { Icon } from '@/components/Icon';
import Loader from '@/components/Loader';
// @ts-expect-error This component is not yet in TS
import SubmitButton from '@/components/SubmitButton';
import TenantList from '@/components/TenantList';
import WizardButton from '@/components/WizardButton';
import { TenantsStore, UserStore } from '@/store';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function stringOrNull(val) {
    return typeof val === 'string' || val == null;
}
export default tsx.componentFactoryOf().create({
    name: 'login',
    props: {
        hideForget: p(Boolean).default(false),
        loginLabel: p(String).default('Login'),
        tenantId: p.ofType().validator(stringOrNull).required,
        hideBackBtn: p(Boolean).default(false),
        delaySamlRedirect: p(Boolean).default(false),
        initialUsername: p(String).optional,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            username: this.initialUsername ?? '',
            password: '',
            samlLoading: !this.delaySamlRedirect,
            tabindexBase: utils.getTabindexBase(),
        };
    },
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        initialFocus() {
            if (this.initialUsername == null) {
                return 'username';
            }
            else {
                return 'password';
            }
        },
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        clearData() {
            this.username = '';
            this.password = '';
        },
        /** @returns The currently selected tenant from the store if we have one. */
        getCurrentTenant(tenantId) {
            return TenantsStore.getTenant()(tenantId);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        doSubmit() {
            this.$withRef('submit', ref => {
                // Even when we have rewritten the SubmitButton in typescript,
                // we will still need to keep this ignore, as vue-tsx-support
                // doesn't expose methods on components. So we need to check
                // if there is a type-safe way to trigger this method.
                ref.onClick();
            });
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        async submit(tenant) {
            if (this.password === '' || this.username === '') {
                throw new Error('Please enter a username and password.');
            }
            const tenantId = tenant.map(t => t.id);
            const res = await UserStore.loginWithUsername({
                data: {
                    tenantId: tenantId.extract(),
                    username: this.username,
                    password: this.password,
                },
                loginMethod: {
                    tag: 'username-password',
                    tenantId,
                },
            });
            return res.addCallbacks({
                onAfterSuccess: () => tsx.emitOn(this, 'onLogin', undefined),
            });
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        renderLoginWarning(warning) {
            const { messages } = warning;
            const msg = utils.ifExpr(messages.length < 2, () => [messages[0].text, <br />], () => (<ul class="p-0 pb-1 text-left pl-3 m-0">
                        {messages.map(({ text }) => (<li>{text}</li>))}
                    </ul>));
            return [msg, 'Close this message to continue.'];
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        renderSaml(tenant) {
            if (this.delaySamlRedirect && !this.samlLoading) {
                return (<div class="d-flex justify-content-center">
                        <WizardButton icon={LogIn} onClick={() => {
                        this.samlLoading = true;
                    }}>
                            Log in with SSO
                        </WizardButton>
                    </div>);
            }
            else {
                tsx.emitOn(this, 'onSamlLogin', tenant);
                return [
                    <div class="m-2 text-muted text-center">
                        Opening your institutions login screen
                    </div>,
                    <Loader scale={2}/>,
                ];
            }
        },
        /* Render the login screen for the given tenant.
         *
         * Pass `Nothing` as the tenant if there is no tenant. In this case a
         * generic login screen is rendered.
         */
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        renderLogin(tenant) {
            if (tenant.isJust() && tenant.extract().ssoProviderId.isJust()) {
                return this.renderSaml(tenant.extract());
            }
            return (<div class="login">
                    <b-form onSubmit={this.doSubmit}>
                        <b-form-group label="Username">
                            <input v-focus={this.initialFocus === 'username'} ref="username" class="form-control" type="text" placeholder="Enter your username" name="username" value={this.username} onInput={event => {
                    this.username = event.target.value;
                }} onKeydown={m.enter(this.doSubmit)} tabindex={this.tabindexBase + 1} autocomplete="username"/>
                        </b-form-group>

                        <b-form-group label="Password">
                            <input v-focus={this.initialFocus === 'password'} class="form-control" type="password" placeholder="Enter your password" name="password" value={this.password} onInput={event => {
                    this.password = event.target.value;
                }} onKeydown={m.enter(this.doSubmit)} tabindex={this.tabindexBase + 2} autocomplete="current-password"/>
                        </b-form-group>

                        <div class={{
                    'd-flex': true,
                    'align-items-center': true,
                    'justify-content-between': !this.hideForget,
                    'justify-content-end': this.hideForget,
                }}>
                            {utils.ifOrEmpty(!this.hideForget, () => {
                    const params = {};
                    tenant.map(utils.attr('id')).ifJust(tenantId => {
                        params.tenantId = tenantId;
                    });
                    return (<router-link to={{
                            name: 'forgot',
                            params,
                            query: this.$route.query,
                            hash: this.$route.hash,
                        }} class="forget-link" style={{
                            textDecoration: 'underline !impotant',
                        }} tabindex={this.tabindexBase + 4}>
                                        Forgot password
                                    </router-link>);
                })}

                            <SubmitButton ref="submit" label={this.loginLabel} submit={() => this.submit(tenant)} waitAtLeast={0} duration={0} scopedSlots={{
                    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
                    warning: ({ warning }) => this.renderLoginWarning(warning),
                }} tabindex={this.tabindexBase + 3}/>
                        </div>
                    </b-form>
                </div>);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        renderTenantList(tenants) {
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            const buildUrl = (tenant) => new Just({
                name: 'login',
                params: { tenantId: tenant.id },
                query: this.$route.query,
                hash: this.$route.hash,
            });
            return (<div>
                    <TenantList allTenants={tenants} getTenantUrl={buildUrl} focusInput/>
                </div>);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        makeHeader(showBackBtn) {
            const showBtn = showBackBtn && TenantsStore.allTenants().mapOrDefault(t => t.length > 1, true);
            return (<div class="d-flex flex-row align-items-center mb-3">
                    <b-button v-b-popover_right_hover={showBtn ? 'Back to institutions' : ''} style={{
                    opacity: showBtn ? 1 : 0,
                    cursor: showBtn ? 'pointer' : 'default',
                }} onClick={showBtn ? this.clearData : undefined} to={showBtn ? { name: 'login' } : undefined}>
                        <Icon icon={ArrowLeft}/>
                    </b-button>
                    <h3 class="text-center flex-grow mb-0">Login to CodeGrade</h3>

                    {/* This button is just here so that the text is nice and centered */}
                    <b-button style="opacity: 0">
                        <Icon icon={ArrowLeft}/>
                    </b-button>
                </div>);
        },
    },
    watch: {
        tenantId: {
            immediate: true,
            /**
             * When we want to login to a tenant we load this one specifically,
             * this is needed so we can login to hidden tenants when we do know
             * the tenant id. For instance with login links.
             */
            handler() {
                if (this.tenantId != null) {
                    TenantsStore.loadSingleTenant({ tenantId: this.tenantId });
                }
                else {
                    TenantsStore.loadTenants({});
                }
            },
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        const body = Maybe.fromNullable(this.tenantId).caseOf({
            Nothing: () => TenantsStore.allTenants().caseOf({
                Just: tenants => [this.makeHeader(false), this.renderTenantList(tenants)],
                Nothing: () => [<Loader />],
            }),
            Just: tenantId => this.getCurrentTenant(tenantId).caseOf({
                Just: tenant => [
                    this.makeHeader(!this.hideBackBtn),
                    this.renderLogin(Maybe.fromNullable(tenant)),
                ],
                Nothing: () => [<Loader />],
            }),
        });
        return <div class="login">{body}</div>;
    },
});
